import { UserProgress } from '@zeus/index'

/**
 * Libellé de chaque avancement d'un apprenant (#201), partagé par le filtre de
 * la liste des comptes et l'état des participants de la fiche session (#243) :
 * même enum, même définition côté API, donc mêmes mots.
 */
export const USER_PROGRESS_KEYS: Record<UserProgress, string> = {
  [UserProgress.NOT_STARTED]: 'user.progress.notStarted',
  [UserProgress.IN_PROGRESS]: 'user.progress.inProgress',
  [UserProgress.COMPLETED]: 'user.progress.completed',
}
